import { Grid, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import CustomButton from '../../shared/CustomButton';
import CustomCard from '../../shared/CustomCard';
import AddQuiz from './AddQuiz';
import useFetchData from '../hooks/useFetchData';
import { quizMenuList } from '../constants';
import { getQuizDetails, showProgress } from '../../../redux/actions/DealershipActions';
import service from '../../../apis/service';
import { apiEndpoints } from '../../../constants/apiEndpoints';
import { ErrorToast, notifySuccess } from '../../utils/Utils';
import QuizIcon from '../../../assets/quiz';
import ConfirmationDialog from '../../common/ConfirmationDialog';
import DeleteIcon from '../../../assets/DeleteIcon';
import ZeroState from '../../common/ZeroState';
import FileIcon from '../../../assets/FileIcon';

const useStyles = makeStyles({
  topBarContainer: {
    width: 390,
    height: 48,
    justifyContent: 'space-between',
    borderBottomWidth: 1,
    paddingTop: 8,
    paddingRight: 16,
    paddingBottom: 8,
    paddingLeft: 16,
    background: '#FEFEFE',
    borderBottom: '1px solid #E4E7EC',
    display: 'flex',
    alignItems: 'center',
  },
  topBarText: {
    fontFamily: 'Lato !important',
    fontWeight: '600 !important',
    fontSize: '16px !important',
    lineHeight: '140% !important',
    letterSpacing: '0 !important',
    color: '#10182B !important',
  },
  scrollContainer: {
    maxHeight: '70vh',
    overflowY: 'auto',
    paddingRight: '4 !important',
  },
});

const LeftSideQuiz = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { fetchQuizDetails, fetchQuizSeriesList } = useFetchData();
  const [quizId, setQuizId] = useState(null);
  const [openDelete, setOpenDelete] = useState(false);
  const overview = useSelector((state) => state?.getQuizSeries?.quizSeriesOverview) || [];
  const { id: activeQuizId } = useSelector((state) => state?.getQuiz?.quizDetails);
  const [openQuizPopup, setOpenQuizPopup] = useState(false);
  const [edit, setEdit] = useState(false);
  useEffect(() => {
    if (overview?.quizzes?.length > 0) {
      const firstQuizId = overview.quizzes[0].id;
      fetchQuizDetails(firstQuizId);
    } else {
      dispatch(getQuizDetails([], null));
    }
  }, [dispatch, fetchQuizDetails, overview.quizzes]);
  const handleOpenQuiz = () => {
    setOpenQuizPopup(true);
    setEdit(false);
  };
  const handleCloseQuiz = () => {
    setOpenQuizPopup(false);
    setQuizId(null);
  };
  const handleCloseConfirmDeleteQuiz = () => setOpenDelete(false);

  const handleDeleteQuiz = async () => {
    dispatch(showProgress(true));
    await service
      .delete(apiEndpoints.QUIZ_BY_ID.replace('ID', quizId))
      .then(() => {
        fetchQuizSeriesList(overview?.id, false);
        dispatch(showProgress(false));
        notifySuccess('Deleted Successfully');
        handleCloseConfirmDeleteQuiz();
      })
      .catch((error) => {
        dispatch(showProgress(false));
        ErrorToast(error);
      });
  };
  const handleMenuItemClick = (e, name) => {
    e.stopPropagation();
    const clickedId = e.currentTarget.getAttribute('data-id');
    setQuizId(clickedId);
    if (name === 'Edit Quiz') {
      setEdit(true);
      setOpenQuizPopup(true);
    } else if (name === 'Remove Quiz') {
      setOpenDelete(true);
    }
  };
  const handleClick = ({ currentTarget: { id } }) => {
    fetchQuizDetails(id);
  };
  return (
    <Grid container direction="column" spacing={1} style={{ padding: '0px 10px' }}>
      <Grid item>
        <Grid container direction="row" justifyContent="space-between" className={classes.topBarContainer}>
          <Grid item>
            <Typography className={classes.topBarText}>{`Quizzes (${overview?.quizzes?.length || 0})`}</Typography>
          </Grid>
          <Grid item>
            {overview?.quizzes?.length > 0 && (
              <CustomButton label="+   Add Quiz" type="primary" size="medium" onClick={handleOpenQuiz} />
            )}
          </Grid>
        </Grid>
      </Grid>
      <Grid item className={classes.scrollContainer}>
        <Grid container direction="column">
          {overview?.quizzes?.map((item, i) => (
            <Grid item key={item.id} xs={12}>
              <CustomCard
                id={item?.id}
                name={item?.name}
                staticThumbnail={<QuizIcon />}
                title={item?.name}
                subTitle={`Quiz ${i + 1}`}
                thirdTitle={`Publish Date: ${item.publishDate}`}
                width="100%"
                height="79px"
                grey
                menu
                menuItems={quizMenuList}
                handleMenuItemClick={handleMenuItemClick}
                handleClick={handleClick}
                clicked={activeQuizId === item?.id}
              />
            </Grid>
          ))}
          {overview?.quizzes?.length === 0 && (
            <Grid item xs={12}>
              <ZeroState
                Icon={FileIcon}
                title="No Quizzes Added."
                text="Add a quiz for the quiz series to be live."
                style={{ paddingBottom: '100px', marginTop: '40px' }}
                cardWidth="100%"
                btnText="+ Add Quiz"
                btnAction={() => {
                  setEdit(false);
                  setOpenQuizPopup(true);
                }}
              />
            </Grid>
          )}
        </Grid>
      </Grid>
      {openQuizPopup && (
        <AddQuiz isOpen seriesId={overview?.id} quizId={edit ? quizId : null} handleClose={handleCloseQuiz} />
      )}
      {openDelete && (
        <ConfirmationDialog
          title="Are you sure you want to delete this Quiz?"
          subText="Once you delete it, you will not be able to recover it."
          onClose={handleCloseConfirmDeleteQuiz}
          isOpen={openDelete}
          confirmFn={handleDeleteQuiz}
          disagreeText="Cancel"
          agreeText="Delete"
          Icon={DeleteIcon}
          width="335px"
          height="229px"
        />
      )}
    </Grid>
  );
};
export default LeftSideQuiz;
